import React from 'react';
import HighchartsReact from 'highcharts-react-official';

import { MasterDetailChartConfig } from 'src/components/MasterDetailRenderer/MasterDetailRenderer';
import { BasicPivotItem } from 'src/worker/pivotWorker.types';
import { generateMasterDetailChartConfig } from './MasterDetailChart.utils';
import Highcharts from 'highcharts';

type MasterDetailChartProps = {
  parentId: string;
  config: MasterDetailChartConfig;
  data: BasicPivotItem[];
};

export const MasterDetailChart = (props: MasterDetailChartProps) => {
  const { parentId, config, data } = props;
  const chartConfig = generateMasterDetailChartConfig(parentId, config, data);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
      <div style={{ width: '90%', maxWidth: '800px' }}>
        <HighchartsReact highcharts={Highcharts} options={chartConfig} />
      </div>
    </div>
  );
};
